import { Injectable } from '@angular/core';
import { DataObject } from '@shared/models/data-object.model';
import { MethodErrorHandler } from './error-handler.interface';
import { CbreAlertService } from '@cbre/alerts';
import { L10nTranslationService } from 'angular-l10n';
import { MainFormService } from '@records/controls/record-container/main-form.service';
import { UntypedFormArray } from '@angular/forms';

const dictionaryErrors = {
  invalidContact: 'graphql: Invalid contact',
  invalidRole: 'graphql: Invalid role',
  invalidCompany: 'graphql: Invalid company',
  invalidLocation: 'graphql: Invalid location',
  companyAndLocationCombo: 'graphql: Company and Location combo not found company id',
  marshalData: 'Failed to marshal data',
  partyRoleMap: 'partyRoleMap cache is empty',
  lovValidationFailed: 'Lov Validation failed',
  userMessageOnPanic: 'user message on panic',
};
@Injectable()
export class AddCompanyContactRoleErrorService implements MethodErrorHandler {
  constructor(
    private cbreAlertsService: CbreAlertService,
    private translationService: L10nTranslationService,
    private mainFormService: MainFormService
  ) {}

  public handleError(failingPayload?: DataObject, error?: DataObject): void {
    if (error.error && error.error.ids) {
      const errorIds = error.error.ids;
      errorIds.forEach(errorInstance => this.processErrorMessage(failingPayload, errorInstance));
    }
  }

  private processErrorMessage(failingPayload, error: DataObject): void {
    const errorType = this.getKeyError(error.description, dictionaryErrors);
    if (errorType != null) {
      let target = null;
      if (
        ['invalidRole', 'invalidCompany', 'companyAndLocationCombo', 'lovValidationFailed', 'invalidLocation'].includes(
          errorType
        )
      ) {
        const companyId = failingPayload['addCompanyContactRole.company_id'];
        const company_contact_role = this.mainFormService.mainForm.get(
          'company_contact_role_addresses'
        ) as UntypedFormArray;
        const companyCtrl = company_contact_role.controls.find(control => control.value.company_id == companyId);
        const company = companyCtrl.value;
        target = company.party_organization_display_name || company.company_legal_name || 'a company';
      }

      const message = this.translationService.translate(
        `detailsErrors.error.edpResponse.addCompanyContactRole.${errorType}`,
        {
          target,
        }
      );
      this.cbreAlertsService.showInfoSnackBar(message, { duration: 40000 });
    }
  }

  private getKeyError(errorsDesc: string, errors: DataObject): string {
    return Object.keys(errors).find(errKey => errorsDesc.includes(errors[errKey]));
  }
}
